import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';

const CTASection: React.FC = () => {
  return (
    <section className="relative py-20 px-6" style={{ backgroundColor: '#1E2A47' }}>
      {/* Sophisticated background effects */}
      <div className="absolute inset-0" style={{ 
        background: `linear-gradient(to bottom, #1E2A47, #2C3E50, #1E2A47)` 
      }}>
        {/* Elegant pulsing orbs */}
        {[...Array(6)].map((_, i) => (
          <motion.div
            key={`cta-orb-${i}`}
            className="absolute rounded-full blur-xl"
            style={{
              left: `${20 + i * 15}%`,
              top: `${30 + (i % 3) * 20}%`,
              width: `${60 + i * 20}px`,
              height: `${60 + i * 20}px`,
              background: 'radial-gradient(circle, rgba(75, 123, 181, 0.3) 0%, transparent 70%)',
            }}
            animate={{
              scale: [1, 1.3, 1],
              opacity: [0.2, 0.5, 0.2],
            }}
            transition={{
              duration: 3 + i * 0.5,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.8,
            }}
          />
        ))}
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <h2 className="text-4xl font-light text-white mb-6">
            The best revenge is massive success.
          </h2>
          <p className="text-2xl text-gray-200">
          The world rewards those who act, hesitation is a luxury you can’t afford.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Link to="services" smooth={true} duration={500}>
            <motion.button
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 0 40px rgba(75, 123, 181, 0.6)",
              }}
              whileTap={{ scale: 0.95 }}
              animate={{
                boxShadow: [
                  "0 0 20px rgba(75, 123, 181, 0.3)",
                  "0 0 40px rgba(75, 123, 181, 0.5)",
                  "0 0 20px rgba(75, 123, 181, 0.3)",
                ]
              }}
              transition={{
                boxShadow: {
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }
              }}
              className="text-white px-12 py-4 rounded-lg text-xl font-semibold hover:bg-opacity-90 transition-all duration-300 flex items-center space-x-3 mx-auto"
              style={{
                backgroundColor: '#2C3E50',
                border: '1px solid rgba(75, 123, 181, 0.3)'
              }}
            >
              <span className="text-2xl">💎</span>
              <span>Make Them Remember You</span>
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;